// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1048":"4cd1d3a0989db2d8","4079":"bed218a56490fce6","5930":"bed218a56490fce6"}[chunkId] + ".css";
};